<template>
    <div class="modal_bg" @click="fnEvent(false)" v-if="show"></div>
    <div class="modal_layer" v-if="show">
        <div class="modal_title">
            <span>{{ title }}</span>
            <div class="close_btn" @click="fnEvent(false)">
                <img src="@/assets/common/close.png" alt="close" />
            </div>
        </div>
        <div class="modal_content" :class="props.isBg ? 'bg' : ''">
            <div :class="[props.customClass?.wrap]">
                <template v-if="props.type === 'nation'">
                    <template v-for="(item, idx) in props.list">
                        <label class="chk">
                            <input
                                :disabled="author.clfCd !== 99"
                                type="checkbox"
                                :checked="item.state === 1"
                                v-model="state.checkedList[idx]"
                                @change="toggleNation(idx, state.checkedList[idx])"
                            />
                            <span></span>
                            <p>
                                {{ item.name }}
                            </p>
                        </label>
                    </template>
                </template>
                <template v-else-if="props.type === 'monitoring'">
                    <template v-for="(item, idx) in props.list">
                        <div>
                            {{ item.label }}
                            <input
                                type="number"
                                v-model.number="datas.monitValue[idx]"
                                :disabled="author.clfCd !== 99"
                                @change="checkNumber(idx)"
                            />
                            %
                            <span class="bold">이상</span>
                        </div>
                    </template>
                </template>
                <template v-else-if="props.type === 'email'">
                    <div class="email_modal">
                        <div>
                            <p>이름</p>
                            <input type="text" placeholder="이름" v-model="emailForm.name" disabled />
                        </div>
                        <div>
                            <p>작성자 이메일</p>
                            <input
                                type="email"
                                placeholder="보내는 사람 이메일"
                                v-model="emailForm.email"
                                @input="checkMailPattern(0)"
                                disabled
                            />
                        </div>
                        <div v-if="!emailForm.isPattern[0]">
                            <p class="email_error">{{ emailForm.patternErr }}</p>
                        </div>
                        <div>
                            <p>받는사람 이메일</p>
                            <input type="email" placeholder="받는사람 이메일" v-model="emailForm.toEmail" @input="checkMailPattern(1)" />
                        </div>
                        <div v-if="!emailForm.isPattern[1]">
                            <p class="email_error">{{ emailForm.patternErr }}</p>
                        </div>
                        <div>
                            <p>제목</p>
                            <input type="text" placeholder="제목" v-model="emailForm.title" />
                        </div>
                        <div>
                            <p>상태</p>
                            <input
                                type="text"
                                placeholder="신고 상태"
                                :value="emailForm.state === 0 ? '신고 전' : emailForm.state === 1 ? '신고완료' : '신고 실패'"
                                disabled
                            />
                        </div>
                        <div>
                            <p>내용</p>
                            <textarea placeholder="신고 내용" v-model="emailForm.content"></textarea>
                        </div>
                    </div>
                </template>
                <template v-else-if="props.type === 'report'">
                    <div class="report_modal">
                        <!-- <div>
                            <p>계정</p>
                            <input type="text" placeholder="X 계정 정보" v-model="reportForm.twitterId" disabled />
                        </div> -->
                        <div>
                            <p>상태</p>
                            <input
                                type="text"
                                placeholder="신고 상태"
                                :value="reportForm.state === 0 ? '신고 전' : reportForm.state === 1 ? '신고 완료' : '신고 실패'"
                                disabled
                            />
                        </div>
                        <div>
                            <p>비고</p>
                            <textarea placeholder="비고" v-model="reportForm.remarks" disabled></textarea>
                        </div>
                    </div>
                </template>
                <template v-else-if="props.type === 'partner'">
                    <div class="partner_warp">
                        <img style="width: 50%" :src="require('@/assets/seoulInstitute.png')" alt="" />
                        <img style="width: 40%" :src="require('@/assets/aroLogo.png')" alt="" />
                    </div>
                </template>
            </div>
        </div>
        <div class="modal_btn_wrap" v-show="props.useBtn && props.type !== 'nation'">
            <button v-if="yes" class="modal_btn" :class="[props.customClass?.button]" @click="fnEvent(true)">
                {{ yes }}
            </button>
            <button v-if="no" class="modal_btn" @click="fnEvent(false)">
                {{ no }}
            </button>
        </div>
    </div>
</template>

<script lang="ts">
    import { userStore, inject } from "@/BaseComponent";
    import { emailPattern } from "@/services/checkForm";
    import { defineComponent, reactive, watch } from "vue";

    export default defineComponent({
        props: {
            title: String,
            customClass: Object,
            list: Array<any>,
            columns: Array<any>,
            show: Boolean,
            no: String,
            yes: String,
            type: String,
            isBg: Boolean,
            data: Object,
            useBtn: Boolean,
        },
        emits: ["close", "update", "toggleNation"],
        setup(props, { emit }) {
            const author = inject("author") as any;
            const user = userStore();
            const state = reactive({
                checkedList: [] as Array<boolean>,
                password: "" as string,
                password_ck: "" as string,
                errorMessage: "" as string,
                errorCode: "" as string,
                data: props.list,
            });

            const datas = reactive({
                monitValue: [0, 0] as Array<number>,
            });
            const email = reactive({
                name: "" as string,
                email: "" as string,
                toEmail: "" as string,
                title: "" as string,
                content: "" as string,
                isPattern: [true, true] as Array<boolean>,
                patternErr: "" as string,
                state: 0 as number,
            });
            const report = reactive({
                twitterId: user.userInfo?.twitterId as string,
                state: 0 as number,
                remarks: "" as string,
                sns: 0 as number,
            });
            const emailForm = reactive({ ...email });
            const reportForm = reactive({ ...report });
            watch(
                () => props.list,
                (newVal) => {
                    if (newVal && newVal.length > 0) {
                        state.checkedList = newVal.map((item: any) => item.state === 1);
                        state.data = newVal;
                        datas.monitValue = [newVal[0].value, newVal[1].value];
                    }
                },
            );

            watch(
                () => props.show,
                () => {
                    if (props.show) {
                        document.body.style.overflow = "hidden";
                    } else {
                        document.body.style.overflow = "auto";
                    }
                },
            );
            watch(
                () => props.data,
                (newData) => {
                    if (newData) {
                        emailForm.name = newData.senderName;
                        emailForm.email = newData.senderMail;
                        emailForm.toEmail = newData.receiverMail;
                        emailForm.title = newData.mailTitle;
                        emailForm.content = newData.mailContent;
                        emailForm.state = newData.state;
                        reportForm.twitterId = user.userInfo?.twitterId;
                        reportForm.state = newData.state;
                        reportForm.remarks =
                            newData.twitterEtc === "" ? newData.twitterEtc : "추가로 필요한 내용은 파이썬측과 논의 후 추가 예정";
                        reportForm.sns = newData.sns;
                    }
                },
            );

            const fnEvent = (result: boolean) => {
                let value = "" as any;
                if (result) {
                    switch (props.type) {
                        case "email":
                            if (checkReportValue()) {
                                if (emailForm.isPattern.every((item) => item === true)) {
                                    if (confirm("이메일을 전송하시겠습니까?")) {
                                        value = emailForm;
                                    } else {
                                        break;
                                    }
                                } else {
                                    return alert("이메일 형식을 확인해주세요");
                                }
                            } else {
                                break;
                            }
                            break;

                        case "nation":
                        case "monitoring":
                            value = datas;
                            break;

                        case "report":
                            if (confirm("신고를 하시겠습니까?")) {
                                if (!reportForm.twitterId) {
                                    alert("X 계정을 설정 후 이용해 주세요");
                                } else {
                                    value = reportForm;
                                }
                            }
                            break;
                    }
                    emit("close", result, value);
                    resetForm();
                } else {
                    emit("close", result);
                    resetForm();
                }
            };

            const resetForm = () => {
                datas.monitValue = [];
                Object.assign(emailForm, email);
                Object.assign(reportForm, report);
            };

            const toggleNation = (idx: number, states: boolean) => {
                let checkbox = states ? 1 : 0;
                let checkedData;
                if (state.data && state.checkedList.some((value) => value === true)) {
                    checkedData = { idx: state.data[idx]?.idx, checkbox };
                    emit("toggleNation", checkedData);
                } else {
                    alert("최소 1개는 선택되어야 합니다.");
                    state.checkedList[idx] = true;
                    return;
                }
            };

            const checkNumber = (idx: number) => {
                const value = datas.monitValue[idx];
                if (props.list && (value < 0 || value > 100)) {
                    alert("값은 0과 100 사이여야 합니다.");
                    datas.monitValue[idx] = props.list[idx].value;
                }
            };

            const checkReportValue = () => {
                if (emailForm.name === "") {
                    alert("이름을 입력해주세요");
                    return false;
                }
                if (emailForm.email === "" || emailForm.toEmail === "") {
                    alert("이메일을 입력해주세요");
                    return false;
                }
                1;
                if (emailForm.title === "") {
                    alert("제목을 입력해주세요");
                    return false;
                }
                if (emailForm.content === "") {
                    alert("내용을 입력해주세요");
                    return false;
                }
                return true;
            };

            const checkMailPattern = (idx: number) => {
                let email = "" as string;
                if (idx === 0) email = emailForm.email;
                if (idx === 1) email = emailForm.toEmail;
                const res = emailPattern(email);
                if (res.code === 0) {
                    if (idx === 0) emailForm.isPattern[0] = true;
                    if (idx === 1) emailForm.isPattern[1] = true;
                } else {
                    if (idx === 0) emailForm.isPattern[0] = false;
                    if (idx === 1) emailForm.isPattern[1] = false;
                    emailForm.patternErr = "* " + res.content;
                }
            };

            return { fnEvent, props, state, user, datas, toggleNation, checkNumber, author, emailForm, checkMailPattern, reportForm };
        },
    });
</script>
<style scoped>
    .chk {
        width: calc(25% - 10px);
        display: flex;
        align-items: center;
    }

    .chk > p {
        padding-left: 10px;
    }
    .modal_content > .email_wrap > .email_modal,
    .modal_content > .report_wrap > .report_modal {
        width: 100%;
        flex-direction: column;
        align-items: flex-start;
        gap: 10px;
    }
    .modal_content > .email_wrap,
    .modal_content > .report_wrap {
        width: 100%;
    }
    .email_modal > div,
    .report_modal > div {
        width: 100%;
        display: flex;
        flex-direction: row;
        gap: 5px;
        justify-content: space-between;
        align-items: center;
    }
    .email_modal > div:last-child,
    .report_modal > div:last-child {
        align-items: unset;
    }

    .email_modal > div > input,
    .report_modal > div > input {
        box-sizing: border-box;
        width: 83%;
        height: 50px;
        padding: 10px;
        border: 1px solid #dfdfdf;
        line-height: 52px;
    }
    .email_modal > div > textarea,
    .report_modal > div > textarea {
        box-sizing: border-box;
        font-family: "Neo";
        resize: none;
        border: 1px solid #dfdfdf;
        width: 83%;
        height: 200px;
        padding: 10px;
    }
    .email_modal > div > .email_error {
        padding-left: 140px;
        font-size: 13px;
        color: red;
    }
    .partner {
        min-width: 370px;
        min-height: 120px;
    }
    .partner img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }
</style>
